import { useQuery } from 'urql';
import { useUrlContext } from '../../contexts/UrlContext/UrlContext';
import { useSchoolIdContext } from '../../contexts/SchoolIdContext/SchoolIdContext';
import { formatChildPath, formatPathnameToSchoolSlug } from '../helpers/formatPathnameToSchoolSlug';
import { schoolPageBySlugQuery } from './schoolPageBySlugQuery';

export const useSchoolPageBySlugQuery = () => {
  const { url, childPath } = useUrlContext();
  const schoolId = useSchoolIdContext();
  const [result] = useQuery({
    query: schoolPageBySlugQuery,
    variables: {
      slug: formatPathnameToSchoolSlug(url.pathname, childPath),
      id: schoolId,
      path: formatChildPath(childPath),
    },
  });

  return result;
};
